define('PDPSchema.Entry', [
    'PDPSchema.Item.Model',
    'PDPSchema.Product.Model',
    'PDPSchema.ProductDetails.Full.View'
], 
function () {
    'use strict';

    return {
        mountToApp: function (container) {
            //Load the three files above which extend their respective native files
        }
    };
});
